import { Theme, createStyles, makeStyles } from '@material-ui/core';

const TAB_PANEL_HEIGHT = 65;
export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tabPanel: {
      padding: 0,
      backgroundColor: theme.palette.background.paper,
      height: `calc(100% - ${TAB_PANEL_HEIGHT}px)`,
    },
    container: {
      height: '100%',
      border: `1px solid ${theme.palette.divider}`,
      backgroundColor: theme.palette.background.paper,
      overflow: 'hidden',
      paddingBottom: 10,
    },
    tabBar: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: theme.palette.background.default,
      height: 47,
    },
    tabBtn: {
      padding: '13px 22px',
      backgroundColor: 'transparent',
      cursor: 'pointer',
    },
    activeTab: {
      backgroundColor: theme.palette.background.paper,
    },
    tabBtnTxt: {
      fontSize: 15,
      fontWeight: 400,
      color: theme.palette.text.secondary,
    },
    tabActiveTxt: {
      color: theme.palette.text.primary,
    },
    body: {
      padding: '40px 25px',
      height: '100%',
      overflow: 'auto',
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
    },
    innerTabPanel: {
      display: 'none',
      backgroundColor: theme.palette.background.paper,
    },
    activTab: {
      display: 'block',
    },
    title: {
      fontSize: 18,
      fontWeight: 500,
      color: theme.palette.text.primary,
      lineHeight: '100%',
    },
    disc: {
      fontSize: 14,
      color: theme.palette.text.secondary,
      fontWeight: 400,
      lineHeight: '100%',
      marginTop: 7,
    },
    pannelContainer: {
      marginTop: 30,
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: 5,
    },
    panelHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: theme.palette.background.default,
      height: 46,
      padding: '0 20px',
    },
    leftContent: {
      display: 'flex',
    },
    rightContent: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    panelTxt: {
      fontSize: 15,
      fontWeight: 500,
      color: theme.palette.text.primary,
    },
    groupBtn: {
      marginLeft: 16,
      '& .MuiButton-root': {
        width: 45,
        height: 25,
      },
    },
    unSelected: {
      color: theme.palette.text.disabled,
      backgroundColor: theme.palette.action.disabledBackground,
    },
    panelBody: {
      backgroundColor: theme.palette.background.paper,
    },
    table: {
      minWidth: 650,
    },
    formControl: {
      width: '100%',
    },
    headerCell: {
      height: 15,
      paddingTop: 12,
      paddingBottom: 7,
    },
    headerCellTxt: {
      fontSize: 14,
      fontWeight: 400,
      color: theme.palette.text.primary,
    },
    trashIcon: {
      fontSize: 20,
    },
    input: {
      fontSize: 15,
      fontWeight: 400,
    },
    gridContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: 13,
    },
    g1: {
      width: 24,
    },
    headerContainer: {
      marginBottom: 30,
    },
    bottom0: {
      marginBottom: 0,
    },
    checkbox: {
      width: 24,
      height: 24,
    },
    fullWidth: {
      marginLeft: 37,
    },
    pt3: {
      paddingTop: 0,
      marginBottom: 0,
    },
  })
);
